import React, { useEffect, useState } from "react";
import styles from "./bursary.module.css";
import { Col, Radio, Row, Typography } from "antd";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomButton from "../../../../../../common/custom-button/custom-button";
import {
  createStudentBursary,
  fetchStudentBursaries,
} from "../../../../../../services/student";
import { formatDate } from "../../../../../../utils/format-date/format-date";
import CustomTable from "../../../../../../common/custom-table/custom-table";
import { toast } from "react-toastify";

const Bursary = ({ studentID }) => {
  const [loading, setLoading] = useState(false);
  const [bursaryName, setBursaryName] = useState("");
  const [bursaryAmount, setBursaryAmount] = useState();
  const [bursaryList, setBursaryList] = useState([]);
  const [needBursary, setNeedBursary] = useState(true);

  const columns = [
    {
      title: "Bursary name",
      dataIndex: "bursary_name",
      key: "bursary_name",
      render: (value) => value || "-",
    },
    {
      title: "Bursary amount",
      dataIndex: "bursary_amount",
      key: "bursary_amount",
      render: (value) => value || "-",
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value) => (value ? formatDate(value) : "-"),
    },
  ];

  useEffect(() => {
    studentID && getStudentBursaries();
  }, [studentID]);

  const getStudentBursaries = async () => {
    try {
      setLoading(true);
      const response = await fetchStudentBursaries(studentID);
      if (response?.data) {
        setBursaryList(response?.data?.data?.bursary_details);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const onSubmitBursary = async () => {
    try {
      setLoading(true);
      if (!bursaryAmount || !bursaryName) {
        toast.error("Please enter details");
      }

      const payload = {
        bursary_details: {
          bursary_name: bursaryName,
          bursary_amount: bursaryAmount,
        },
        need_bursary: true,
        student_id: studentID,
      };

      const response = await createStudentBursary(payload);
      if (response?.status) {
        setBursaryName("");
        setBursaryAmount();
        toast.success("Created successfully");
      }
      getStudentBursaries();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  return (
    <div className={styles.bursary}>
      <Row gutter={30} className={styles.header}>
        <Col span={8}>
          <Typography className={styles.formLabel}>Need Bursary ?*</Typography>
          <Radio.Group
            value={needBursary}
            options={[
              { value: true, label: "Yes" },
              { value: false, label: "No" },
            ]}
            onChange={(e) => setNeedBursary(e?.target?.value)}
          />
        </Col>
        {needBursary ? (
          <>
            <Col span={6}>
              <CustomTextfield
                id={"name"}
                placeholder={"Enter name"}
                label={"Bursary Name*"}
                size={"large"}
                value={bursaryName}
                onChange={(e) => setBursaryName(e?.target?.value)}
                labelColor={"#171717"}
              />
            </Col>
            <Col span={6}>
              <CustomTextfield
                id={"amount"}
                type={"number"}
                placeholder={"Enter amount"}
                label={"Bursary Amount*"}
                size={"large"}
                value={bursaryAmount}
                onChange={(e) => setBursaryAmount(e?.target?.value)}
                labelColor={"#171717"}
              />
            </Col>
            <Col span={4}>
              <CustomButton
                title="Apply"
                size={"large"}
                onClick={() => onSubmitBursary()}
                style={{ width: "100px" }}
              />
            </Col>
          </>
        ) : (
          <></>
        )}
      </Row>

      <div style={{ paddingTop: "20px" }}>
        <CustomTable
          columns={columns}
          dataSource={bursaryList}
          loading={loading}
          showMoreIcon={false}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default Bursary;
